import { MouseEvent } from "react";
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
interface ButtonProps {
    className?: string;
    children: any;
    disabled?: boolean;
    isLoading?: boolean;
    style?: "primary" | "secondary" | "outline";
    type?: "button" | "submit";
    onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
    id?: string;
    fullWidth?: boolean
  }
  
  const Button = ({
    className = "",
    children,
    disabled = false,
    style = "primary",
    type = "button",
    isLoading = false,
    fullWidth = false,
    onClick = () => ({} as unknown as void),
    ...props
  }: ButtonProps) => {
    const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
      if (disabled) {
        return;
      }

      onClick(e);
    };
  
    const styles = {
      primary:
        "heading-2 rounded-[12px] py-3 px-4 bg-[#383181] text-white hover:bg-[#383181]/80 active:bg-[#383181]/80 touch-manipulation",
      secondary:
        "heading-2 rounded-[12px] py-3 px-4 bg-white hover:bg-yellow-main active:bg-yellow-main/90 text-black touch-manipulation",
      outline:
        "heading-3 rounded-[6px] py-2 px-4 text-[#383181] active:bg-white border-[#383181] border-[2px] hover:text-white hover:bg-[#383181] active:bg-[#383181] touch-manipulation",
    };
  
    return (
      <button
        {...props}
        onClick={handleClick}
        disabled={disabled}
        type={type}
        className={`cursor-pointer relative disabled:bg-[#656281] ${styles[style] || styles["primary"]
        } ${className} ${fullWidth ? 'w-full' : ""}`}
      >
        {children}
        {isLoading && (
          <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center bg-inherit">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 animate-spin text-white"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="12" y1="2" x2="12" y2="6"></line>
              <line x1="12" y1="18" x2="12" y2="22"></line>
              <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
              <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
              <line x1="2" y1="12" x2="6" y2="12"></line>
              <line x1="18" y1="12" x2="22" y2="12"></line>
              <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
              <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
            </svg>
          </div>
        )}
      </button>
    );
  };
  
  export default Button;